/**
 * Gets the review app prefix from sessionStorage if on a review app
 * @returns The review prefix (e.g., "/325") or empty string if not on a review app
 */
const getReviewPrefix = (): string => {
  if (typeof window === 'undefined') {
    return '';
  }

  if (window.location.hostname.startsWith('review')) {
    const reviewPrefix = sessionStorage.getItem('review');
    return reviewPrefix || '';
  }

  return '';
};

/**
 * Composes a URL by prepending the review app prefix (if applicable) to the given path
 * @param path - The path to compose the URL with (e.g., "/login")
 * @returns The composed URL with review prefix if on a review app, otherwise just the path
 */
const composeURL = (path: string): string => {
  const reviewPrefix = getReviewPrefix();
  return `${reviewPrefix}${path}`;
};

export default composeURL;
